module.exports = __webpack_public_path__ + "static/media/urbanFutures_white_icon.24134f07.svg";